import React, { useContext, useEffect, useState } from 'react';
import fincityIcon from '../../images/icons/CompanyGrading/Fincity.svg';
import plus from '../../images/icons/CompanyGrading/plus.svg';
import { navigate } from 'gatsby';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import EditIcon from '@material-ui/icons/Edit';
import EditCompany from './EditCompany';
import GroupDefault from '../../images/icons/CompanyGrading/GroupDefault.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteIndustry, readPresignedUrl } from '../../common/constants/api';
import Toast from '../../common/components/Toast/Toast';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';
import ConfirmationModal from '../../common/components/Modal/ConfirmationModal';

const Card = props => {
  let {
    data,
    industryOptions,
    companyTypeOptions,
    segmentOptions,
    totalBanks
  } = props;
  const [showEditCompanyModal, setShowEditCompanyModal] = useState(false);
  const [showEditCompany, setEditCompany] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [askConfirmation, setConfirmation] = useState(false);

  const context = useContext(DeveloperDataContext);

  const handleDelete = () => {
    setConfirmation(true);
  };

  const handleDeleteCompany = () => {
    setConfirmation(false);
    deleteIndustry(data?.industryId).then(res => {
      context.setAppData({
        ...context.appData,
        companyReload: !context.appData.companyReload
      });
    });
    Toast(
      'success',
      'Company has been deleted successfully',
      '3000',
      'top-center'
    );
  };

  useEffect(() => {
    readPresignedUrl(data?.docUrl).then(res => setImageUrl(res));
  }, [data]);

  return (
    <React.Fragment>
      <div className="max-w-full relative hover:shadow-lg cursor-pointer">
        <div className="bg-white rounded-md shadow-sm py-3 px-2">
          <div className="w-full flex justify-between">
            <div className="w-full flex flex-row items-center px-1">
              <img
                className="block w-11 h-11 mt-1 rounded-full"
                src={imageUrl ? imageUrl : GroupDefault}
              />
              <div className="p-2 cursor-pointer">
                <p className="text-black-400 text-sm w-44">
                  {data?.companyName}
                </p>
              </div>
            </div>

            <div className="w-9 flex gap-x-2">
              <div className="w-full flex justify-end">
                <FontAwesomeIcon
                  icon={faTrash}
                  className="text-grey-920"
                  onClick={e => {
                    handleDelete();
                    e.stopPropagation();
                  }}
                />
              </div>
              <div
                className="w-full flex justify-end cursor-pointer"
                onClick={e => {
                  setShowEditCompanyModal(true), setEditCompany(true);
                  e.stopPropagation();
                }}
              >
                <EditIcon className="text-base text-grey-920 mr-2 cursor-pointer" />
              </div>
            </div>
            <ConfirmationModal
              headText="Company Details Card"
              bodyText="This will delete the Company detail card."
              proceedTextShow={true}
              buttonShow={true}
              handleClickYes={handleDeleteCompany}
              askConfirmation={askConfirmation}
              setConfirmation={setConfirmation}
            />
            {showEditCompany ? (
              <EditCompany
                data={data}
                imageUrl={imageUrl}
                showModal={showEditCompanyModal}
                setShowModal={setShowEditCompanyModal}
                setEditCompany={setEditCompany}
                industryOptions={industryOptions}
                companyTypeOptions={companyTypeOptions}
                segmentOptions={segmentOptions}
              />
            ) : null}
          </div>
          <hr className="my-3" style={{ borderColor: '#dee0f0' }} />
          <div className="px-1">
            <div className="flex justify-between w-75">
              <div className="flex">
                <p
                  className="text-sm font-light text-black-800 font-sans"
                  style={{ width: '58px' }}
                >
                  Type
                </p>
                <span className="text-black-800 ml-1">:</span>
                <p className="ml-1 text-black-400">
                  {data?.typeOfCompany || '--'}
                </p>
              </div>
              <div className="flex">
                <p className="text-sm font-light text-black-800 font-sans">
                  Industry
                </p>
                <span className="text-black-800 mx-1">:</span>
                <p className="text-black-400">{data?.industryName || '--'}</p>
              </div>
            </div>
            <div className="flex">
              <p
                className="text-sm font-light text-black-800 font-sans"
                style={{ width: '58px !important' }}
              >
                Segment
              </p>
              <span className="text-black-800 ml-1">:</span>
              <p className="ml-1 text-black-400">{data?.segmentName || '--'}</p>
            </div>
          </div>
        </div>
        <div
          className="h-10 rounded-b-md flex justify-between items-center px-2"
          style={{ backgroundColor: '#EAECE2' }}
        >
          <div
            className="cursor-pointer"
            onClick={e => {
              navigate(`/app/companyprofile/${data?.industryId}`);
              e.stopPropagation;
            }}
          >
            <img src={fincityIcon} width="30px" className="inline" />
            <span
              className="w-4 h-4 rounded-full text-xs ml-2"
              style={{ color: '#1584E3' }}
            >
              {totalBanks}
            </span>
          </div>
          <div
            className="mr-1 cursor-pointer"
            onClick={e => {
              navigate(`/app/companyprofile/${data?.industryId}`);
              e.stopPropagation;
            }}
          >
            <img src={plus} className="w-4 h-4 inline" />
            <span className="ml-2 text-xs" style={{ color: '#1584E3' }}>
              Add Bank
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Card;
